import React from 'react'
import 'core-js/stable'
import { isRedButtonTestActive, redButtonTheme } from './utils/red-button-test'
import { ThemeProvider } from 'styled-components'
import { atdsTheme } from '@at/design-system-foundation'
import { bootstrap18, SinglePageApp } from '@at/sauron-platform-spa'
import { cache } from './graphql/cache'
import { UserSignInProvider } from '@at/connected-signin'

import Main from './main'

const App = () => {
    return (
        <SinglePageApp
            appName="sauron-search-results-app"
            graphQL={{
                enabled: true,
                cache,
            }}
        >
            <ThemeProvider theme={isRedButtonTestActive ? redButtonTheme : atdsTheme}>
                <UserSignInProvider>
                    <Main />
                </UserSignInProvider>
            </ThemeProvider>
        </SinglePageApp>
    )
}

bootstrap18(App, { dangerouslySuppressRecoverableErrors: true })
